import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing-page',
      component: () => import('./views/LandingPage')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup')
    },
    {
      path: '/invite-friend/:groupId',
      props: true,
      name: 'invite-friend',
      component: () => import('./views/InviteFriends')
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: () => import('./views/VerifyEmail')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword')
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('./views/ChangePassword')
    },
    {
      path: '/app',
      component: () => import('./views/Home'),
      children: [
        {
          path: 'dashboard',
          component: () => import('./views/Dashboard'),
          children: [
            {
              path: '',
              name: 'prediction',
              component: () => import('./views/Dashboard/Predictions')
            },
            {
              path: 'result',
              component: () => import('./views/Dashboard/Results'),
              children: [
                {
                  path: '',
                  name: 'round-1',
                  component: () => import('./views/Dashboard/Results/Round')
                },
                {
                  path: ':roundId',
                  name: 'round',
                  props: true,
                  component: () => import('./views/Dashboard/Results/Round')
                }
              ]
            },
            {
              path: 'leaderboard',
              component: () => import('./views/Dashboard/Leaderboards'),
              children: [
                {
                  path: '',
                  name: 'leaderboard-group',
                  component: () =>
                    import('./views/Dashboard/Leaderboards/Group')
                },
                {
                  path: 'continent',
                  name: 'leaderboard-continent',
                  component: () =>
                    import('./views/Dashboard/Leaderboards/Continent')
                },
                {
                  path: 'global',
                  name: 'leaderboard-global',
                  component: () =>
                    import('./views/Dashboard/Leaderboards/Global')
                },
                {
                  path: 'monthly-winners',
                  name: 'monthly-winners',
                  component: () =>
                    import('./views/Dashboard/Leaderboards/MonthlyWinners')
                }
              ]
            }
          ]
        },
        {
          path: 'profile/',
          name: 'profile',
          component: () => import('./views/Profile')
        },
        {
          path: 'edit-profile/',
          name: 'edit-profile',
          component: () => import('./views/EditProfile')
        },
        {
          path: 'league/',
          component: () => import('./views/League'),
          children: [
            {
              path: '',
              component: () => import('./views/League/Fixtures'),
              children: [
                {
                  path: '',
                  props: true,
                  component: () => import('./views/League/Fixtures/Matches')
                },
                {
                  path: 'fixtures/:dateParam',
                  props: true,
                  component: () => import('./views/League/Fixtures/Matches')
                }
              ]
            },
            {
              path: 'table',
              component: () => import('./views/League/Tables')
            }
          ]
        },
        {
          path: 'settings/',
          name: 'settings',
          component: () => import('./views/Settings')
        },
        {
          path: 'settings/change-password',
          name: 'settings-change-password',
          component: () => import('./views/PrivateChangePassword')
        },
        {
          path: '/admin/result-input',
          name: 'result-input',
          component: () => import('./views/ResultInput')
        },
        {
          path: '/admin/move-fixtures',
          component: () => import('./views/MoveFixtures'),
          children: [
            {
              path: '',
              name: 'move-fixtures',
              component: () => import('./views/MoveFixtures/Round')
            },
            {
              path: ':roundId',
              name: 'move-fixtures-round',
              props: true,
              component: () => import('./views/MoveFixtures/Round')
            }
          ]
        },
        {
          path: '/admin/track-prediction',
          component: () => import('./views/TrackPrediction'),
          children: [
            {
              path: '',
              name: 'track-prediction',
              component: () => import('./views/TrackPrediction/Round')
            },
            {
              path: ':roundId',
              name: 'track-prediction-round',
              props: true,
              component: () => import('./views/TrackPrediction/Round')
            }
          ]
        }
      ]
    },
    {
      path: '/engagement-rules',
      name: 'engagement-rules',
      component: () => import('./views/EngagementRules')
    },
    {
      path: '/create-group',
      name: 'create-group',
      component: () => import('./views/CreateGroup')
    },
    {
      path: '/create-group/invite',
      name: 'create-group-invite',
      component: () => import('./views/CreateGroupInvite')
    },
    {
      path: '/user-prediction',
      name: 'user-prediction',
      component: () => import('./views/UserPrediction'),
      children: [
        {
          path: ':userId',
          name: 'player-round-1',
          component: () => import('./views/UserPrediction/Round')
        },
        {
          path: ':userId/:roundId',
          name: 'player-round',
          props: true,
          component: () => import('./views/UserPrediction/Round')
        }
      ]
    },
    {
      path: '*',
      redirect: '/app/dashboard'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = [
    'login',
    'signup',
    'verify-email',
    'forgot-password',
    'change-password',
    'landing-page'
  ]

  const adminPages = [
    'settings',
    'settings-change-password',
    'move-fixtures',
    'move-fixtures-1',
    'move-fixtures-round',
    'track-prediction',
    'track-prediction-round',
    'result-input'
  ]

  const authRequired = !publicPages.includes(to.name)
  const loggedIn = localStorage.getItem('access_token')

  if (authRequired && !loggedIn) {
    return next('/')
  }

  const userObj = JSON.parse(localStorage.getItem('user'))
  const isNotAdminPage = !adminPages.includes(to.name)

  if (userObj && (userObj.role === 'super_admin' && isNotAdminPage)) {
    return next('/app/settings')
  }

  if ((loggedIn && !authRequired) || (to.path === '/app' || to.path === '')) {
    return next('/app/dashboard')
  }

  next()
})

export default router
